import {
  PageReferenceActivity,
  PageReferenceActivityGroup,
  PageReferenceStep,
} from '@gkn-ili/views/dist/OrderDocumentation';
import { ModifyStateFunction } from './types';
import { orderService } from '../../utils/orderService';
import { ContentItemView } from '@gkn-ili/views/dist/PageContent';
import { MockOrderService } from '@gkn-ili/views/dist/mocks/order-service';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getOrderEditActions(_setState: ModifyStateFunction) {
  return {
    editStep: async (
      reference: PageReferenceStep,
      name: string,
      description: string,
      afterKey: string,
      content: ContentItemView['content'],
    ) => {
      await orderService.editStep(reference.stepKey, { name, description, depends: [], content }, afterKey);
    },
    editActivityGroup: async (
      reference: PageReferenceActivityGroup,
      name: string,
      description: string | undefined,
      content: ContentItemView['content'],
      afterKey: string,
    ) => {
      await orderService.editActivityGroup(
        reference.activityGroupKey,
        {
          name,
          description,
          content,
        },
        afterKey,
      );
    },
    editActivity: async (
      reference: PageReferenceActivity,
      data: Parameters<MockOrderService['editActivity']>[1],
      afterKey: string,
    ) => {
      await orderService.editActivity(reference.activityKey, data, afterKey);
    },
    deleteStep: async (reference: PageReferenceStep) => {
      await orderService.deleteStep(reference.stepKey);
    },
    deleteActivityGroup: async (reference: PageReferenceActivityGroup) => {
      await orderService.deleteActivityGroup(reference.activityGroupKey);
    },
    deleteActivity: async (reference: PageReferenceActivity) => {
      await orderService.deleteActivity(reference.activityKey);
    },
    createStep: async (routingItemKey: string, name: string, description: string, afterKey: string) => {
      await orderService.createStep(routingItemKey, { name, description }, afterKey);
    },
    createActivityGroup: async (reference: PageReferenceStep, name: string, description: string, afterKey: string) => {
      await orderService.createActivityGroup(reference.stepKey, { name, description }, afterKey);
    },
    createActivity: async (
      reference: PageReferenceActivityGroup,
      data: Parameters<MockOrderService['createActivity']>[1],
      afterKey: string,
    ) => {
      await orderService.createActivity(reference.activityGroupKey, data, afterKey);
    },
  };
}
